import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { LayoutDashboard, FileText, History, TestTube, LogOut, Building2, Inbox } from 'lucide-react';
import { Dashboard } from './pages/Dashboard';
import { WorkflowList } from './pages/WorkflowList';
import { WorkflowEdit } from './pages/WorkflowEdit';
import { Versions } from './pages/Versions';
import { TestPanel } from './pages/TestPanel';
import { Tenants } from './pages/Tenants';
import { TenantForm } from './pages/TenantForm';
import { TenantDetail } from './pages/TenantDetail';
import { Tickets } from './pages/Tickets';
import { TicketDetail } from './pages/TicketDetail';
import { AuthGate } from './components/AuthGate';
import { api } from './api/client';

export default function App() {
  return (
    <AuthGate>
      <div className="min-h-screen flex">
        <Sidebar />
        <main className="flex-1 p-8 overflow-auto">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/workflows" element={<WorkflowList />} />
            <Route path="/workflows/new" element={<WorkflowEdit />} />
            <Route path="/workflows/:id" element={<WorkflowEdit />} />
            <Route path="/versions" element={<Versions />} />
            <Route path="/test" element={<TestPanel />} />
            <Route path="/tenants" element={<Tenants />} />
            <Route path="/tenants/new" element={<TenantForm />} />
            <Route path="/tenants/:id" element={<TenantDetail />} />
            <Route path="/tenants/:id/edit" element={<TenantForm />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/tickets/:id" element={<TicketDetail />} />
          </Routes>
        </main>
      </div>
    </AuthGate>
  );
}

function Sidebar() {
  const navItems = [
    { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/workflows', icon: FileText,        label: 'Workflows' },
    { to: '/versions',  icon: History,         label: 'Versions' },
    { to: '/tenants',   icon: Building2,        label: 'Tenants' },
    { to: '/tickets',   icon: Inbox,            label: 'Support Tickets' },
    { to: '/test',      icon: TestTube,         label: 'Test Panel' },
  ];

  function handleSignOut() {
    api.clearToken();
    window.location.reload();
  }

  return (
    <aside className="w-64 bg-white border-r border-gray-200 flex flex-col">
      <div className="p-6 border-b border-gray-200">
        <h1 className="text-xl font-semibold text-gray-900">ProMed KB</h1>
        <p className="text-xs text-gray-500 mt-1">Support Agent Admin</p>
      </div>
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-brand-50 text-brand-700'
                  : 'text-gray-700 hover:bg-gray-100'
              }`
            }
          >
            <Icon size={18} />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-gray-200">
        <button
          onClick={handleSignOut}
          className="flex items-center gap-3 px-3 py-2 w-full rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors"
        >
          <LogOut size={18} />
          Sign out
        </button>
      </div>
    </aside>
  );
}
